export default {
  items: state => state.items,
  item: state => id => state.items.find(item => item.id === id),
  sort: state => state.sort,
  more: state => state.more,
  loading: state => state.loading,
  total: state => state.total,
  updated: state => state.updated,
  overallCount: state => state.overallCount,
  defaultSort: state => state.defaultSort,
};
